import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MQService, MQComponent, ConfigService, MQMessage, OAuth2Service } from '@ngxsuit';
import { Subscription } from 'rxjs/Subscription';
import { HttpClient } from '@angular/common/http';
import { StoreService } from "Admin/services"

interface MQ_MSG {
    data:any
}

interface NOTIFY_MSG extends MQMessage{
    brief:string,
    detail:string
    time?:number,
}


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends MQComponent implements OnInit {
    title:string = '';
    subscription:Subscription;
    @ViewChild('layoutheaderbar', { read: ViewContainerRef }) _headerbar;
    notifies:[NOTIFY_MSG];
    admin:any = {};

    constructor(
        public router: Router, 
        protected mq:MQService, 
        private gv:ConfigService, 
        private http:HttpClient,
        private storeService: StoreService,
        private oauthservice: OAuth2Service) {
        super(mq);
        this.router.events.subscribe((val) => {
            if (val instanceof NavigationEnd && window.innerWidth <= 992) {
                this.toggleSidebar();
            }
        });
        
    }

    toggleSidebar() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle('push-right');
    }

    rltAndLtr() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle('rtl');
    }

    refreshUser() {
        this.oauthservice.fetchAdminInfo();
    }

    onLoggedout() {
        console.log('onLoggedout');
        this.http.post(this.gv.getString('admin_logout'), {
            _token: this.gv.getString('csrf_token'),
            is_ajax:1
        }, { withCredentials: true }).subscribe(data => {
            localStorage.removeItem('admin_login');
            this.router.navigate(['/login']);
        });
    }


    ngOnInit() {
        if (localStorage.getItem('PRIVATE_NOTIFIES')) {
            this.notifies = JSON.parse(localStorage.getItem('PRIVATE_NOTIFIES'));
        } else {
            this.notifies = [{
                brief:'No Message',
                time:Date.now(),
                detail:''
            }];
        }

        this.admin = this.oauthservice.adminInfo();
        super.listenOn('user-authed', user => {
            this.admin = user;
        })

        super.listenOn('update-header-title', (msg: MQMessage) => {
            this.title = msg['title'];
        });

        super.listenOn('update-header-headerbar', (msg: MQMessage) => {
            this._headerbar.remove(0);
            if (msg) {
                this._headerbar.createEmbeddedView(msg['component']);
            }
        });

        super.listenOn('header-notification', (msg: NOTIFY_MSG) => {
            this.handlePrivteNotify(msg);
        })
    }

    private handlePrivteNotify(notify:NOTIFY_MSG) {
        notify.time = Date.now();
        this.notifies.unshift(notify);
        if (this.notifies) {
            while(this.notifies.length>20) {
               this.notifies.pop();
            }
            localStorage.setItem('PRIVATE_NOTIFIES', JSON.stringify(this.notifies));
        }
    }
}
